module.exports = __webpack_public_path__ + "img/FAVICON-EK-candy.svg";